import { styled } from "styled-components"
import Header from "./header"
import Content from "./content";

const Main = () => {
  return(
    <Container>
      <Header />
      <Content />
    </Container>
  )
}

export default Main

const Container = styled.section`
  background:url(/imgs/home/background/main.png) no-repeat center center/cover;
`

